/* eslint-disable array-callback-return */
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect } from "react";
import MUIDataTable from "mui-datatables";
import { createTheme, ThemeProvider, styled } from "@mui/material/styles";
import { Link, useLocation } from "react-router-dom";
import NavigateNextIcon from '@mui/icons-material/NavigateNext';
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import {
  Stack,
  Divider,
  Paper,
  Grid,
  Box,
  Button,
  Typography,
  IconButton,
  Table,
  TableHead,
  TableBody,
  TableCell,
  TableRow,
} from "@mui/material";

import moment from "moment";
import { lightBlue } from "@mui/material/colors";
import ToPrintPageLabroomManagement from "../components/ToPrintPageLabroomManagement";
/*------------------ External Function -----------*/
import { convertToThaiDate, convertToEngDate } from "../components/functions/GlobalFunctions";
/*------------------ Redux -----------------------*/
import { useSelector, useDispatch } from 'react-redux';
import { fetchBookingInOnePeriod } from '../store/PgBookDateSlice';
import { fetchAllTestResvInfoInOnePeriod, fetchAllTestResvInfo } from '../store/TestReservationSlice';
import { fetchMemberInfoByUserType } from '../store/MemberInfoSlice';

/*----------------------- Style ------------------*/
const Item = styled(Paper)(({ theme }) => ({
  backgroundColor: theme.palette.mode === 'dark' ? '#1A2027' : '#FFF',
  ...theme.typography.body2,
  padding: theme.spacing(1),
  textAlign: 'center',
  fontFamily: 'THSarabunNew',
  color: theme.palette.text.secondary
}));

/*----------------- theme ------------------------*/
const theme = createTheme({
  typography: {
    allVariants: {
      fontFamily: 'THSarabunNew',
      fontSize: 14
    }
  },

  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          fontFamily: 'THSarabunNew',
        },
      }
    },
    MuiStack: {
      styleOverrides: {
        root: {
          fontFamily: 'THSarabunNew',
        },
      }
    },
  }
});

const muidatatabletheme = createTheme({
  components: {
    MUIDataTableHeadCell: {
      styleOverrides: {
        root: {
          backgroundColor: lightBlue['50'],
        }
      }
    },
    MuiTablePagination: {
      caption: {
        fontFamily: 'THSarabunNew',
      },
    },
    MuiButton: {
      styleOverrides: {
        root: {
          fontFamily: 'THSarabunNew',
        },
      }
    },
    MuiSelect: {
      styleOverrides: {
        root: {
          fontFamily: 'THSarabunNew',
        },
      }
    },
  }
});

/*--------------------------- PageLabroomManagement -----------------------*/
function PageLabroomManagement() {
  const location = useLocation();
  const [rows, setRows] = useState([]);

  /*------------------------ Redux : MemberInfo ----------------*/
  const meminfodispatch = useDispatch();
  useEffect(() => {
    meminfodispatch(fetchMemberInfoByUserType('USR03'));
  }, [meminfodispatch]);
  const meminfobyusrtype = useSelector((state) => state.memberinfostate.meminfobyusrtype);

  const [invigilatorList, setInvigilatorList] = useState([]);
  useEffect(() => {
    if (meminfobyusrtype?.length !== 0) {
      let invigilatorlist = meminfobyusrtype?.map(e => ({
        'pers_id': e['tbmember.pers_id'],
        'name': e['tbmember.tbmemberinfos.mem_rank'] +
          e['tbmember.tbmemberinfos.mem_fname'] + ' ' +
          e['tbmember.tbmemberinfos.mem_lname']
      }));

      setInvigilatorList(invigilatorlist);
    }
  }, [meminfobyusrtype]);

  const alltestresvdispatch = useDispatch();
  useEffect(() => {
    alltestresvdispatch(fetchAllTestResvInfo());
  }, [alltestresvdispatch]);
  const alltestresvlist = useSelector((state) => state.testresvinfostate.alltestresvarr);

  //console.log('alltestresvlist--->', alltestresvlist.data);
  /*-------------------------------------------------------------*/
  const months = [
    "มกราคม", "กุมภาพันธ์", "มีนาคม", "เมษายน", "พฤษภาคม", "มิถุนายน",
    "กรกฎาคม", "สิงหาคม", "กันยายน", "ตุลาคม", "พฤศจิกายน", "ธันวาคม"
  ];

  const [curr_month, setCurrMonth] = useState(new Date().getMonth());
  const [curr_year, setCurrYear] = useState(new Date().getFullYear() + 543);
  const [movedirection, setMoveDirection] = useState(0);

  /*---------------------- Function : Month Selection -----------------------*/
  const handlePrevMonth = () => {
    setCurrMonth(curr_month - 1);
    setMoveDirection(-1);
  }

  const handleNextMonth = () => {
    setCurrMonth(curr_month + 1);
    setMoveDirection(1);
  }

  let m = ((curr_month % months.length) + months.length) % months.length;
  useEffect(() => {
    switch (movedirection) {
      case 1:
        if (m === 0) {
          setCurrYear(curr_year + 1);
        }
        break;
      case -1:
        if (m === 11) {
          setCurrYear(curr_year - 1);
        }
        break;
      default:
    }
  }, [m]);

  /*---------------------- Redux : Test Reservation -> booking period --------*/
  let fd_month = moment(new Date((curr_year - 543), m, 1)).format('YYYY-MM-DD');
  let ld_month = moment(new Date((curr_year - 543), m + 1, 0)).format('YYYY-MM-DD');

  /*--------- Redux : fetching test reservation by date ----------------*/
  const testresvbydatedispatch = useDispatch();
  useEffect(() => {
    testresvbydatedispatch(fetchAllTestResvInfoInOnePeriod({ 's_date': fd_month, 'e_date': ld_month }));
  }, [testresvbydatedispatch, curr_year, m]);
  const res_byresvcode = useSelector((state) => state.testresvinfostate.testresvbyperiod);

  /*--------------------- Redux to help LabRoomSelection to get reqNumSeat -----*/
  const bookdatedispatch = useDispatch();
  useEffect(() => {
    bookdatedispatch(fetchBookingInOnePeriod({ 's_date': fd_month, 'e_date': ld_month }));
  }, [bookdatedispatch, curr_year, m]);

  const seatstate = useSelector(state => state.seatstate.seatstatus);

  /*--------------------------------- TestTypeCheckFunc -------------------*/
  const TestTypeCheckFunc = (reqarr, labroom) => {
    let newreqarr = reqarr.filter(e => e.testlabroom === labroom);
    let typecheckarr = newreqarr.reduce((a, b) => {
      a.push(b.testtype);
      return a;
    }, []);

    //console.log('TestTypeCheckFunc ---> typecheckarr : ', labroom, ' : ', typecheckarr);

    const typearr = ['รอเลือกรูปแบบการสอบ', 'Random Test', 'Adaptive Test', 'คละรูปแบบการสอบ'];
    if (typecheckarr.length !== 0) {
      if (typecheckarr.every(elm => elm === typecheckarr[0])) {
        return typearr[typecheckarr[0]];
      } else {
        return typearr[3];
      }
    } else {
      return typearr[0];
    }
  }

  /*--------------------------------- CriteriaCheckFunc -------------------*/
  const CriteriaCheckFunc = (reqarr, labroom) => {
    let newreqarr = reqarr.filter(e => e.testlabroom === labroom);
    let criteriacheckarr = newreqarr.reduce((a, b) => {
      a.push(b.showscoringcriteria);
      return a;
    }, []);

    const criteriaarr = [
      'รอเลือกการแสดงเกณฑ์การผ่าน', 'ไม่แสดงเกณฑ์การผ่าน', 'แสดงเกณฑ์การผ่าน', 'คละการแสดงเกณฑ์การผ่าน'
    ];

    if (criteriacheckarr.length !== 0) {
      if (criteriacheckarr.every(elm => elm === criteriacheckarr[0])) {
        return criteriaarr[criteriacheckarr[0] + 1];
      } else {
        return criteriaarr[3];
      }
    } else {
      return criteriaarr[0];
    }
  }

  /*--------------------------------- TmpLabroomInfoFunc -------------------*/
  const TmpLabroomInfoFunc = (date, time) => {
    let reqdata = alltestresvlist.data
      .filter(elm => elm['tbtestreservation.testreqdate'] === date)
      .filter(elm => elm['tbtestreservation.testreqtime'].split(':')[0]
        .concat(elm['tbtestreservation.testreqtime'].split(':')[1]) === time.split('-')[0]);

    let labroominfo = [
      { 'lab1': seatstate.data?.totalseat?.lab1, 'invigilator': null, 'testtype': null, 'criteria': null },
      { 'lab2': seatstate.data?.totalseat?.lab2, 'invigilator': null, 'testtype': null, 'criteria': null },
      { 'lab3': seatstate.data?.totalseat?.lab3, 'invigilator': null, 'testtype': null, 'criteria': null },
      { 'lab6': seatstate.data?.totalseat?.lab6, 'invigilator': null, 'testtype': null, 'criteria': null },
    ];

    let seatcount = [0, 0, 0, 0,];
    reqdata.map(lb => {
      //console.log('lb------->', lb);
      switch (lb['testlabroom']) {
        case 'lab1':
          labroominfo[0]['lab1'] = seatstate.data?.totalseat?.lab1 - (++seatcount[0]);
          labroominfo[0]['invigilator'] = invigilatorList.filter(elm => elm.pers_id === lb['invigilator'])[0]['name'] ?? null;
          labroominfo[0]['testtype'] = TestTypeCheckFunc(reqdata, 'lab1');
          labroominfo[0]['criteria'] = CriteriaCheckFunc(reqdata, 'lab1');
          break;
        case 'lab2':
          labroominfo[1]['lab2'] = seatstate.data?.totalseat?.lab2 - (++seatcount[1]);
          labroominfo[1]['invigilator'] = invigilatorList.filter(elm => elm.pers_id === lb['invigilator'])[0]['name'] ?? null;
          labroominfo[1]['testtype'] = TestTypeCheckFunc(reqdata, 'lab2');
          labroominfo[1]['criteria'] = CriteriaCheckFunc(reqdata, 'lab2');
          break;
        case 'lab3':
          labroominfo[2]['lab3'] = seatstate.data?.totalseat?.lab3 - (++seatcount[2]);
          labroominfo[2]['invigilator'] = invigilatorList.filter(elm => elm.pers_id === lb['invigilator'])[0]['name'] ?? null;
          labroominfo[2]['testtype'] = TestTypeCheckFunc(reqdata, 'lab3');
          labroominfo[2]['criteria'] = CriteriaCheckFunc(reqdata, 'lab3');
          break;
        case 'lab6':
          labroominfo[3]['lab6'] = seatstate.data?.totalseat?.lab6 - (++seatcount[3]);
          labroominfo[3]['invigilator'] = invigilatorList.filter(elm => elm.pers_id === lb['invigilator'])[0]['name'] ?? null;
          labroominfo[3]['testtype'] = TestTypeCheckFunc(reqdata, 'lab6');
          labroominfo[3]['criteria'] = CriteriaCheckFunc(reqdata, 'lab6');
          break;
        default:
      }
    });

    //console.log('labroominfo ---> ', date, ' : ', time, ' : ', labroominfo);

    return labroominfo;
  }

  /*------------------------- MuiDataTables : Rows Data --------------------*/
  const [engdate, setEngDate] = useState([]);
  useEffect(() => {
    let tmp = res_byresvcode?.data.map(e => { return e.testreqdate }).reduce((a, b) => {
      if (!a.find((item) => item === b)) {
        a.push(b);
      }
      return a;
    }, []).map(e => { return e });
    setRows(tmp.map(e => { return [convertToThaiDate(e)] }));
    setEngDate(tmp)
  }, [res_byresvcode]);

  /*------------------------ MuiDataTables : Columns ----------------*/
  const columns = [
    {
      name: "วันที่ทำการสอบ",
      options: {
        filter: true,
        sort: false,
        setCellProps: () => ({
          style: {
            whiteSpace: 'nowrap',
            position: 'sticky',
            width: '1000px',
            textAlign: 'left'
          }
        }),
        setCellHeaderProps: () => ({
          style: {
            whiteSpace: 'nowrap',
            position: 'sticky',
            width: '1000px',
            textAlign: 'left',
            fontWeight: 'bold'
          }
        })
      }
    }
  ];

  /*------------------------ MuiDataTables --> options -------------------*/
  let subtableheaderstyle = { fontSize: '14px', fontFamily: 'THSarabunNew', fontWeight: 'bold', width: 100 };
  const options = {
    filter: false,
    selectableRows: 'none',
    //filterType: 'dropdown',
    //fixedHeader: false,
    elevation: 0,
    print: false,
    search: false,
    viewColumns: false,
    download: false,
    responsive: 'simple',
    rowsPerPage: 10,
    expandableRows: true,
    textLabels: {
      body: {
        noMatch: "ไม่พบข้อมูลที่ต้องการ",
      },
      pagination: {
        next: "หน้าถัดไป",
        previous: "หน้าก่อนหน้า",
        rowsPerPage: "จำนวนแถวต่อหน้า:",
        displayRows: "ของ",
      },
    },
    renderExpandableRow: (rowData, rowMeta) => {
      //console.log('rowData : ', rowData, ' : ', rowMeta)
      return (
        <tr>
          <td colSpan={6}>
            <Table>
              <TableHead>
                <TableRow>
                  <TableCell style={subtableheaderstyle} align='center'>
                    เวลา
                  </TableCell>
                  <TableCell style={subtableheaderstyle} align='center'>
                    จำนวนที่นั่งคงเหลือ
                  </TableCell>
                  <TableCell style={subtableheaderstyle} align='center'>
                    ผู้คุมสอบ
                  </TableCell>
                  <TableCell style={subtableheaderstyle} align='center'>
                    แบบ
                  </TableCell>
                  <TableCell style={subtableheaderstyle} align='center'>
                    รายการการจอง
                  </TableCell>
                  <TableCell style={subtableheaderstyle} align='center'>
                    แสดงเกณฑ์การผ่าน
                  </TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {
                  ['0900 - 1000', '1030 - 1130', '1330 - 1430'].map((elm, i) => {
                    return (
                      <TableRow key={i}>
                        <TableCell style={{ fontSize: '14px', fontFamily: 'THSarabunNew' }} align='center'>
                          {elm}
                        </TableCell>
                        <TableCell style={{ fontSize: '14px', fontFamily: 'THSarabunNew' }} align='center'>
                          { // seat remaining
                            engdate.map(
                              e => (TmpLabroomInfoFunc(e, elm.split(' - ')[0]))
                            )[rowMeta.rowIndex]
                            [location.state.labroom !== 'lab6' ?
                              parseInt(location.state.labroom.slice(-1)) - 1 : 3
                            ][location.state.labroom]
                          }
                        </TableCell>
                        <TableCell style={{ fontSize: '14px', fontFamily: 'THSarabunNew' }} align='center'>
                          { // invigilator
                            engdate.map(
                              e => (TmpLabroomInfoFunc(e, elm.split(' - ')[0]))
                            )[rowMeta.rowIndex]
                            [location.state.labroom !== 'lab6' ?
                              parseInt(location.state.labroom.slice(-1)) - 1 : 3
                            ]['invigilator'] ?? '--'//'รอกำหนดผู้คุมสอบ'
                          }
                        </TableCell>
                        <TableCell style={{ fontSize: '14px', fontFamily: 'THSarabunNew' }} align='center'>
                          { // test type
                            engdate.map(
                              e => (TmpLabroomInfoFunc(e, elm.split(' - ')[0]))
                            )[rowMeta.rowIndex]
                            [location.state.labroom !== 'lab6' ?
                              parseInt(location.state.labroom.slice(-1)) - 1 : 3
                            ]['testtype'] ?? '--'//'รอกำหนดประเภทแบบทดสอบ'
                          }
                        </TableCell>
                        <TableCell style={{ fontSize: '14px', fontFamily: 'THSarabunNew' }} align='center'>
                          <Link to="/PageResvCodeListLabMgmt"
                            style={{ textDecoration: "none" }}
                            state={{
                              'labroom': location.state.labroom,
                              'thdate': rowData[0],
                              'engdate': convertToEngDate(rowData[0]),
                              'time': elm,
                            }}
                          >
                            <Button
                              variant="contained"
                              key={i}
                            >
                              ดูรายการการจอง
                            </Button>
                          </Link>
                        </TableCell>
                        <TableCell style={{ fontSize: '14px', fontFamily: 'THSarabunNew' }} align='center'>
                          { // criteria
                            engdate.map(
                              e => (TmpLabroomInfoFunc(e, elm.split(' - ')[0]))
                            )[rowMeta.rowIndex]
                            [location.state.labroom !== 'lab6' ?
                              parseInt(location.state.labroom.slice(-1)) - 1 : 3
                            ]['criteria'] ?? '--'//'รอเลือกการแสดงเกณฑ์การผ่าน'
                          }
                        </TableCell>
                      </TableRow>
                    )
                  })
                }
              </TableBody>
            </Table>
          </td>
        </tr>
      );// end return
    }
  }

  /*------------------ return -------------------------*/
  return (
    <ThemeProvider theme={theme}>
      <Stack
        divider={<Divider flexItem />}
        spacing={1}
      >
        {/*-------------- Title -----------------*/}
        <Item
          elevation={0}
          sx={{
            fontSize: '24px',
            fontWeight: 'bold',
          }}>
          การจัดการทดสอบ ห้องสอบ {location?.state?.labroom?.toUpperCase()}
        </Item>
        {/*-------------- Month & Year -----------------*/}
        <Item elevation={0}>
          <Box sx={{ width: "100%", display: "flex", justifyContent: "space-between" }}>
            <Box sx={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
              <IconButton onClick={handlePrevMonth}>
                <ChevronLeftIcon />
              </IconButton>
              <Typography variant="prev_month" gutterBottom>
                {months[m === 0 ? 11 : m - 1]} {m === 0 ? curr_year - 1 : curr_year}
              </Typography>
            </Box>
            <Box sx={{
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              fontSize: '18px',
              fontWeight: 'bold',
            }}>
              {months[m]} {curr_year}
            </Box>
            <Box sx={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
              <Typography variant="next_month" gutterBottom>
                {months[(m + 1) % 12]} {m === 11 ? curr_year + 1 : curr_year}
              </Typography>
              <IconButton onClick={handleNextMonth}>
                <NavigateNextIcon />
              </IconButton>
            </Box>
          </Box>
        </Item>

        {/*-------------- DataGrid -----------------*/}
        <Item elevation={0}>
          <ThemeProvider theme={muidatatabletheme}>
            <MUIDataTable
              data={rows}
              columns={columns}
              options={options}
            />
          </ThemeProvider>
        </Item>
        {/*-------------- Backward Button -----------------*/}
        <Item
          elevation={0}
          sx={{
            //fontSize: '24px',
            //fontWeight: 'bold',
            textAlign: 'center'
          }}>
          <Grid container spacing={2}>
            <Grid item xs={6} style={{ display: "flex", justifyContent: "flex-end" }}>
              <Link to="/PageTestManagement"
                style={{ textDecoration: "none" }}
              >
                <Button
                  variant='contained'
                  sx={{
                    fontSize: '16px',
                    fontWeight: 'bold',
                    width: 200, padding: 1, margin: 2
                  }}
                >
                  ย้อนกลับ
                </Button>
              </Link>
            </Grid>
            {/*-------------- Page Print -----------------*/}
            <Grid item xs={6} style={{ display: "flex", justifyContent: "flex-start" }}>
              <ToPrintPageLabroomManagement
                toprint={{
                  'thdatearr': rows,
                  'engdatearr': engdate,
                  'labroom': location.state.labroom,
                  'invlist': invigilatorList
                }}
              />
            </Grid>
          </Grid>
        </Item>
      </Stack>
    </ThemeProvider>
  );
}

export default PageLabroomManagement;
